import { render } from "./milestone-category-navigation.vue?vue&type=template&id=92d23e22&scoped=true&ts=true"
import script from "./milestone-category-navigation.vue?vue&type=script&lang=ts"
export * from "./milestone-category-navigation.vue?vue&type=script&lang=ts"

import "./milestone-category-navigation.vue?vue&type=style&index=0&id=92d23e22&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d23e22"]])

export default __exports__